module.exports = __webpack_public_path__ + "static/gestured.9654554c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gestured.svg
// module id = 445
// module chunks = 35783957827783 172322841747965